import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class OnlineOrderTypeService {
    constructor(private http: AuthHttp) { }

    getOnlineOrderTypes() {
        return this.http.get(AppSettings.apiEndpoint + 'OnlineOrderType/GetOnlineOrderTypes')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order-type.service.ts